<template>
  <div class="flex items-center justify-center min-h-screen bg-surface-ground">
    <div class="text-center">
      <h1 class="text-3xl font-bold text-surface-900 dark:text-surface-0 mb-4">
        Logging you out...
      </h1>
      <i class="pi pi-spinner pi-spin text-4xl text-primary"></i>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useAuth } from '@okta/okta-vue';
import authService from '@/services/AuthService';

const $auth = useAuth();

onMounted(async () => {
  // Clear local tokens first so the nav guard won't redirect us back
  await authService.logout();

  try {
    // Revoke tokens and clear Okta SDK state without hitting sessions/me (CORS)
    await $auth.signOut({ revokeAccessToken: true, revokeRefreshToken: true, clearTokensBeforeRedirect: true });
  } catch (error) {
    console.error('Okta signout error:', error);
    // If Okta signout fails, redirect manually — tokens are already cleared
    window.location.href = '/login';
  }
});
</script>
